import type {
  InsertTagTypeWithGroupNameMutation,
  InsertTagTypeWithGroupNameMutationVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertTagTypeWithGroupNameDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useInsertTagTypeWithGroupName = createMutationHook({
  name: 'insertTagType',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.tag.insert.mutationOptions({ onSuccess }),
  mapInput: (variables: InsertTagTypeWithGroupNameMutationVariables) => ({
    Name: variables.Name ?? '',
    Description: variables.Description ?? null,
    TagGroupName: variables.TagGroupName ?? null,
  }),
  invalidate: (trpc) => [trpc.frontend.tag.pathKey()],
  mapResponse: (result: {
    Id: string;
  }): InsertTagTypeWithGroupNameMutation => ({
    insert_tag_type_one: {
      __typename: 'tag_type',
      TagTypeId: result.Id,
    },
  }),
  graphqlDocument: InsertTagTypeWithGroupNameDocument,
  graphqlVariables: (
    variables: InsertTagTypeWithGroupNameMutationVariables
  ) => ({ ...variables }),
  evictFields: ['tag_type'],
});
